import React from 'react'
import './style.scss'
import { useLanguage } from '../../i18n'
import { FaBalanceScale, FaUsers, FaMedal, FaMapMarkerAlt } from 'react-icons/fa'

const Statistics = () => {
    const { t } = useLanguage();

    const stats = [
        { number: '25+', labelKey: 'stats.casesWon', Icon: FaBalanceScale },
        { number: '1,000', labelKey: 'stats.happyClients', Icon: FaUsers },
        { number: '15+', labelKey: 'stats.yearsExperience', Icon: FaMedal },
        { number: '4', labelKey: 'stats.officeLocations', Icon: FaMapMarkerAlt }
    ]

    return (
        <section className="statisticsArea">
            <div className="container">
                <div className="statsWrapper">
                    {stats.map((stat, index) => {
                        const IconComponent = stat.Icon;
                        return (
                            <div className="statItem" key={index}>
                                <div className="iconBox">
                                    <IconComponent />
                                </div>
                                <h3 className="statNumber">{stat.number}</h3>
                                <p className="statLabel">{t(stat.labelKey)}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    )
}

export default Statistics
